module.exports = __webpack_public_path__ + "static/media/step-8-en.5c50a0bc.jpg";